// Build-time environment for the merchant web app.
//
// The env contract is validated with Zod at module load. Missing or
// malformed values must crash the build (AC-4 of M0-010) — silent
// fallbacks hide prod-only issues like the wrong base URL.

import { z } from "zod";

const EnvSchema = z.object({
  VITE_API_BASE_URL: z
    .string()
    .url("VITE_API_BASE_URL must be a valid URL"),
  VITE_APP_NAME: z.string().min(1).default("Video Marketing Assistant"),
  VITE_THEME: z.enum(["merchant"]).default("merchant"),
});

const parsed = EnvSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const issues = parsed.error.issues
    .map((issue) => `  - ${issue.path.join(".") || "(root)"}: ${issue.message}`)
    .join("\n");
  // Surface the error in the console so the dev server paints a clear
  // error overlay; throwing also aborts the bundle.
  // eslint-disable-next-line no-console
  console.error(`[web-merchant] Invalid env:\n${issues}`);
  throw new Error(`Invalid env:\n${issues}`);
}

export const env = Object.freeze({
  apiBaseUrl: parsed.data.VITE_API_BASE_URL,
  appName: parsed.data.VITE_APP_NAME,
  theme: parsed.data.VITE_THEME,
});

export type Env = typeof env;
